<template>
  <div>
    <template v-if="row.isAudit === undefined || row.isAudit<0">/</template>
    <template v-else>
      <el-tag size="mini" :type="options[row.isAudit].tagType">{{
        options[row.isAudit].text
      }}</el-tag>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: {
        0: {
          tagType: "warning",
          text: this.$lange == "en" ? "To be audited" : "待审核",
        },
        1: {
          tagType: "success",
          text:this.$lange == "en" ? "Have passed" : "已通过",
        },
        2: {
          tagType: "danger",
          text:  this.$lange == "en" ? "Not pass" : "未通过",
        },
        3: {
          tagType: "info",
          text: this.$lange == "en" ? "Not submitted" : "未提交",
        },
      },
      status: {},
    };
  },
  props: {
    row: Object,
    index: Number,
  },
  methods: {},
  mounted() {},
};
</script>